import type {
  Employer,
  EmployerPolicy,
  PolicyEnforcement,
  PolicyName,
} from '@factoryfixinc/ats-interfaces';
import { EmployerPersistence } from './employer.persistence';
import { useMeStore } from '../me/me.store';
import { useEmployerPolicyStore } from './employer-policy.store';
import { arrayToRecord } from '@/utils/objects/array-to-record.util';

export class EmployerService {
  private meStore = useMeStore();
  private employerPersistence = new EmployerPersistence();
  private policyStore = useEmployerPolicyStore();

  constructor() {}

  public async updateEmployer(employerUpdate: Partial<Employer>): Promise<void> {
    const employerId = this.meStore.employer?.id;
    if (!employerId) return;

    await this.employerPersistence.updateEmployer(employerId, employerUpdate);
  }

  public async fetchEmployerPolicies(): Promise<EmployerPolicy[]> {
    const employerId = this.meStore.employer?.id;
    if (!employerId) return [];

    const employerPolicies = await this.employerPersistence.fetchPolicies(employerId);
    this.policyStore.employerPolicies = employerPolicies;
    this.policyStore.employerPoliciesRecord = arrayToRecord(employerPolicies, 'name');
    return employerPolicies;
  }

  public getPolicyByName(policyName: PolicyName): PolicyEnforcement | undefined {
    return this.policyStore.employerPoliciesRecord?.[policyName]?.policy;
  }

  public async updateEmployerPolicies(
    policies: Pick<EmployerPolicy, 'name' | 'policy'>[],
  ): Promise<void> {
    const employerId = this.meStore.employer?.id;
    if (!employerId) return;

    await this.employerPersistence.updatePolicies(employerId, policies);
  }
}
